import { Box, Typography } from '@mui/material';

const DetailRow = ({ label, value }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      pt: 1.5,
      pb: 1,
      borderBottom: '1px solid',
      borderColor: 'divider'
    }}
  >
    <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
      {label}
    </Typography>
    <Typography variant="body1" sx={{ textAlign: 'right', maxWidth: '60%' }}>
      {value}
    </Typography>
  </Box>
);

export default DetailRow;
